import { Drawer } from "antd";
import { DsaUploadFolderDto } from "../../generated/dashboard-client";
import "../../components/design/MoveToFolderModal.scss";
import { DsaFolderThumb } from "./DsaFolderButton";
import { DsaMoveToFolderMenuContent } from "./DsaMoveToFolderMenuContent";

export interface DsaMoveToFolderDrawerProps {
  isVisible: boolean;
  uploadIds: string[];
  folders: DsaUploadFolderDto[];
  activeFolder: DsaUploadFolderDto | null;
  onBack: () => void;
  onCloseMovedToFolder: (save: boolean, folder?: DsaUploadFolderDto) => void;
  onCloseMovedToUploads: (uploadIds: string[]) => void;
  onCloseMovedFolderToFolder: (childFolderId: number, parentFolderId: string) => void;
  onCreateFolderModalClose: (uploadIds: string[], folderToMove?: DsaUploadFolderDto | null, folder?: DsaUploadFolderDto) => void;
  folderToMove: DsaUploadFolderDto | null;
  folderThumbs: DsaFolderThumb[];
  folderNameExists: (folder: DsaUploadFolderDto | null, name: string) => boolean | undefined;
}

export function DsaMoveToFolderDrawer({
  isVisible,
  uploadIds,
  folders,
  activeFolder,
  onBack,
  onCloseMovedToFolder,
  onCloseMovedToUploads,
  onCloseMovedFolderToFolder,
  onCreateFolderModalClose,
  folderToMove,
  folderThumbs,
  folderNameExists
}: DsaMoveToFolderDrawerProps) {
  return (
    <Drawer
      className={"mobile-bottom-menu add-design-to-folder"}
      onClose={() => onCloseMovedToFolder(false)}
      placement={"bottom"}
      visible={isVisible}
      closable={false}
      height={"600px"}
      zIndex={2000}
    >
      <DsaMoveToFolderMenuContent
        uploadIds={uploadIds}
        folders={folders}
        activeFolder={activeFolder}
        onCloseMovedToFolder={onCloseMovedToFolder}
        onCloseMovedToUploads={onCloseMovedToUploads}
        onCloseMovedFolderToFolder={onCloseMovedFolderToFolder}
        folderToMove={folderToMove}
        folderThumbs={folderThumbs}
        folderNameExists={folderNameExists}
        onCreateFolderModalClose={onCreateFolderModalClose}
        isMobile={true}
        onBack={onBack}
      />
    </Drawer>
  );
}
